export default function isIs(value, match) {
  return value === match;
}
